module.exports = __webpack_public_path__ + "static/media/Cats Eyes 09_TYSKA-mixdown.96753283.mp3";